"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetTradePwdWithOldPwdRequest = void 0;
var ResetTradePwdWithOldPwdRequest = /** @class */ (function () {
    function ResetTradePwdWithOldPwdRequest() {
    }
    return ResetTradePwdWithOldPwdRequest;
}());
exports.ResetTradePwdWithOldPwdRequest = ResetTradePwdWithOldPwdRequest;
;
//# sourceMappingURL=resetTradePwdWithOldPwd.request.js.map